export default __webpack_public_path__ + "static/media/Boton_1.02c1b7c9.webp";